import { Getters } from 'vuex-smart-module';
import MarketingFundState from './state';

export default class NotificationsGetters extends Getters<MarketingFundState> {}
